import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import LotteryView from 'src/components/LotteryView';
import config from 'src/config';
import { Lottery } from 'src/util/types';

export default function PublicLotteryPage() {
  const { lotteryId } = useParams<{ lotteryId: string }>();
  const [lottery, setLottery] = useState<Lottery | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchLottery = async () => {
      if (!lotteryId) {
        setLottery(null);
        setError('Lotterie wurde nicht gefunden.');
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const res = await axios.get(`${config.apiUrl}/api/public/lottery/${encodeURIComponent(lotteryId)}`);
        const payload = res?.data?.content ?? res?.data;
        setLottery(!payload || payload.closed ? null : payload);
      } catch (err: any) {
        setLottery(null);
        setError(err?.response?.data?.message || 'Aktuell gibt es keine aktive Lotterie');
      } finally {
        setLoading(false);
      }
    };

    fetchLottery();
  }, [lotteryId]);

  return <LotteryView lottery={lottery} galleryImages={[]} loading={loading} error={error} variant="channel" />;
}
